import environment from "@/modules/environment";
import { getAppFiles, getCommonFiles } from "./getImageFiles";

type Props = {
  src: string;
  alt?: string;
  className?: string;
  imgProps?: JSX.IntrinsicElements["img"];
  ignoreTheme?: boolean;
};

export default function AppImage({ src, alt = src.split(".")[0], className, imgProps, ignoreTheme = false }: Props) {
  const path = ignoreTheme ? src : `light-${src}`;
  const imgData =
    getAppFiles()[`/src/assets/${environment.appName}/${path}`]?.default ||
    getCommonFiles()[`/src/assets/common/${path}`]?.default;

  if (!imgData) return null;
  return (
    <picture>
      {/* {!ignoreTheme && <source srcSet={`dark-${src}`} media="(prefers-color-scheme: dark)" />} */}
      <img
        src={imgData.src}
        width={imgData.width}
        height={imgData.height}
        alt={alt}
        className={className}
        {...imgProps}
      />
    </picture>
  );
}
